export default {
	home: 'Zuhause',
	contact: 'Kontakt',
	aboutUs: 'Über uns',
	logout: 'Ausloggen',
	login: 'Einloggen',
	register: 'Hier anmelden',
	search: 'Suche',
	login_fa: 'Mit Facebook einloggen',
	login_go: 'Melden Sie sich mit Google an',
	sign_in_man: 'Melden Sie sich manuell an',
	username: 'Nutzername',
	password: 'Passwort',
	btn_register: 'Jetzt registrieren',
	btn_lost_pass: 'Passwort vergessen?',
	text_remenber: 'Erinnere dich an mich',
	check_in: 'Check-In',
	itfa_abr: 'INDEPENDENT TELEFOOTBALL ASSOCIATION',
	select_platform: 'Wählen Sie eine Plattform',
	about_us:
		'<p>In order to get as close to <strong>our way</strong> to run a competition as real as possible in FIFA would like to highlight some details about what your experience in this game.</p><p>Currently we have about 800+ players in our Pro Clubs & Groups 1v1 is soon to be held, where many are involved in one or other of the powers that are exclusive to PS4 due to various reasons.</p><p>Esta página web, esta echa para todos ustedes donde habra torneos sobre FIFA 16.</p><p>– 1 VS 1 where you can demonstrate your ability.</p><p>– PRO CLUBS it is a mode of FIFA 16 online game where you can create a Virtual Pro player and play your own position in the field with your fellow realistically as you can live football online. The more games you play and unlock more feats, Virtual Pro unlock your best attributes and appearance options. Play casual games or join a club or create your own to get points with your own club.</p><p>You can also interact with us, MarDar photos from your club oh video, contact us, ask questions and send suggestions and comments on our way as we have the web and Administration page, ensuring to serve them and respond as soon as possible with a problem that have.</p><p><strong>A cordial greeting.</strong></p><p>We hope to meet your expectations with quality and satisfaction quickly because it is our true FIFA16 philosophy of work.</p>',
	text_contact:
		'<p>Thanks for your visit.</p><p>If you have any suggestions, complaints or comments please write, we will be happy to answer.</p>',
	subject: 'Gegenstand',
	email: 'E-mail',
	name: 'Name',
	message: 'Botschaft',
	messages: 'Mitteilungen',
	required: 'Erforderlich',
	submit: 'einreichen',
	return: 'Rückkehr',
	pleaseWait: 'Warten Sie mal...',
	registerTitle: 'Benutzer Registration',
	repeatPassword: 'Wiederhole dein Passwort',
	country: 'Land',
	position: 'Position',
	console: 'Konsole',
	motto: 'Motto',
	selectOption: 'Wähle eine Option',
	allRightsReserved: 'All rights reserved',
	profile: 'Profil',
	myProfile: 'mein Profil',
	friends: 'Freunde',
	edit: 'Bearbeiten',
	editUser: 'Bearbeiten Sie meine Informationen',
	language: 'Sprache',
	save: 'speichern',
	changePassword: 'Passwort ändern',
	currentPassword: 'Jetziges Passwort',
	newPassword: 'Neues Kennwort',
	repeatNewPassword: 'Wiederhole das neue Passwort',
	options: 'Optionen',
	createAdmins: 'Create administrators',
	sliderPrimary: 'Schieberegler primär',
	changeGt: 'Change gamertag',
	toPremium: 'Switch to premium',
	updatedData: 'Update data',
	tutorialCreate: 'Create tutorial',
	bets: 'Wetten',
	textChangeImgSlider:
		'<li>The image should have no more weight than 2MB.</li><li>Minimum resolution 1366 x 598 pixels.</li><li>The only permitted extension is JPG.</li>',
	findImage: 'Image search',
	details: 'Details',
	updatedInfo: 'Aktualisierte Information.',
	create: 'Erstellen',
	title: 'Titel',
	delete: 'Löschen',
	error404: 'Ressource existiert nicht.',
	enterUserId: 'Geben Sie die ID eines Benutzers ein',
	cancel: 'Stornieren',
	confirmTitleDelete: 'Löschen bestätigen',
	confirmTextDelete: 'Sie müssen das ausgewählte Element sicher löschen ?',
	editInfoUser: 'Benutzerinformationen bearbeiten',
	resetPassword: 'Setze dein Passwort zurück',
	enterYourEmail: 'Enter your email',
	myNews: 'Meine Neuigkeiten',
	image: 'Bild',
	published: 'Veröffentlicht',
	modified: 'Geändert',
	comments: 'Bemerkungen',
	date: 'Datum',
	time: 'Zeit',
	createdAgo: 'Erstellt vor',
	content: 'Inhalt',
	cover: 'Titelseite',
	show: 'Show',
	enterIdOrUsername: 'Geben Sie eine Spieler-ID oder einen Benutzernamen ein',
	month: 'Monat | Monate',
	year: 'Jahr | Jahre',
	selectPlatform: 'Wählen Sie eine Plattform',
	langEs: 'Spanish',
	langEn: 'English',
	langPt: 'Portuguese',
	description: 'Beschreibung',
	videoCode: 'Video code',
	order: 'Bestellung',
	tournaments: 'Turniere',
	tournament: 'Turnier',
	favorites: 'Favoriten',
	online: 'Online',
	notices: 'Nachrichten',
	readMore: 'Read more',
	seeAllNews: 'Sehen Sie alle Nachrichten',
	rankingPlayers: 'Spieler-Rangliste',
	rankingTeams: 'Ranking Ausrüstung',
	lastMatches: 'Letzte Spiele',
	round: 'rund | Runden',
	theBest: 'Das beste',
	signings: 'Unterschriften',
	rules: 'Regeln',
	divisions: 'Abteilungen',
	division: 'Einteilung',
	teams: 'Teams',
	team: 'Mannschaft',
	transfers: 'Transfers',
	assistances: 'Hilfen',
	scorer: 'Torschütze | Torschützen',
	transferClose: '{time} links bis zum Schließen',
	transferOpen: '{time} links zu öffnen',
	goal: 'Ziel | Tore',
	assistance: 'assist | hilft',
	goalkeeper: 'Torhüter | Torhüter',
	bestPlayer: 'Bester Spieler',
	point: 'Punkt | Punkte',
	bestDefense: 'Die beste Verteidigung',
	bestOffensive: 'Die beste Offensive',
	goalFavor: 'Ziel zugunsten | Ziele dafür',
	goalAgainst: 'Ziel gegen | Tore gegen',
	player: 'Spieler',
	players: 'Spieler',
	ranking: 'Rangfolge',
	status: 'Status',
	price: 'Preis',
	purchasedBy: 'Erworben von',
	availableMoney: 'Verfügbares Geld',
	free: 'kostenlos',
	signing: 'Unterzeichnet',
	playedGames: 'Spiele gespielt',
	yellowCard: 'gelbe Karte | gelbe Karten',
	redCard: 'rote Karte | rote Karten',
	joinTheMarket: 'Treten Sie dem Markt bei',
	joinTheMarketConfirm:
		'Sind Sie sicher, dass Sie sich der Liste der freien Spieler im Turnier anschließen möchten?',
	yes: 'Ja',
	not: 'Nicht',
	notice: 'Beachten',
	contract: 'Vertrag',
	sellPlayers: 'Spieler verkaufen',
	pendingRounds: 'Ausstehende Runden',
	sellerPlayerConfirm:
		'Sind Sie sicher, dass Sie an den ausgewählten Spieler verkaufen möchten?',
	table: 'Tabelle',
	card: 'Karte | Karten',
	teamWeek: 'Team der Woche',
	nextMatches: 'Nächste Spiele',
	results: 'risultati',
	privateMsgFor: 'Private Nachricht für {user}',
	pj: 'SP',
	pg: 'S',
	pe: 'U',
	pp: 'N',
	gf: 'T',
	gc: 'GT',
	dg: 'D',
	seeDT: 'Siehe Manager',
	matches: 'Streichhölzer',
	quantity: 'Menge',
	training: 'Ausbildung',
	defense: 'Verteidigung',
	midfielders: 'Mittelfeldspieler',
	front: 'Vorderseite',
	award: 'Auszeichnung | Auszeichnungen',
	champion: 'CHAMPION',
	stats: 'Statistiken',
	type: 'Art',
	record: 'Aufzeichnung',
	changeImage: 'Bild ändern',
	addTeam: 'Team hinzufügen',
	textFindNotice:
		'Geben Sie einen oder mehrere Buchstaben ein und drücken Sie die EINGABETASTE',
	sendInvitation: 'Einladung senden',
	createTournament: 'Turnier erstellen',
	editTournament: 'Turnier bearbeiten',
	mode: 'Modus',
	category: 'Kategorie | Kategorien',
	hideTournament: 'Turnier verstecken?',
	deleteAllPlayersOfTeam:
		'Sind Sie sicher, alle Spieler des ausgewählten Teams zu löschen??',
	handOutMoney: 'Geld verteilen',
	add: 'Hinzufügen',
	remove: 'Entfernen',
	transfersClosed: 'Transfers - ist geschlossen',
	transfersOpened: 'Transfer - ist offen',
	transfersClosedMsg:
		'Der Transfer ist geschlossen, die eingeladenen Spieler können das Team betreten.',
	transfersOpenedMsg:
		'Der Transfer ist offen, Spieler, die eingeladen und nicht akzeptiert wurden, können erst bei der nächsten Unterzeichnung in das Team eintreten.',
	open: 'Öffnen',
	close: 'Schließen',
	customButtons: 'Benutzerdefinierte Schaltflächen',
	label: 'Etikette',
	showIn: 'Zeigen in',
	selfLink: 'Auf derselben Seite',
	blankLink: 'Auf einer anderen Seite',
	views: 'Ansichten',
	administrator: 'Administrator | Administratoren',
	enterPlayerNick: 'Geben Sie den Spitznamen eines Spielers ein',
	user: 'Benutzer',
	roundsFinalPhase: 'RUNDEN nach Hause / weg',
	allFinalPhase: 'ALLES GEGEN ALLES / 1Game',
	manualDirectDisposal: 'MANUELLE DIREKTE ENTSORGUNG',
	autoDirectDisposal: 'AUTOMATISCHE DIREKTE ENTSORGUNG',
	numberTeamsDown: 'Anzahl der Teams, die ausgefallen sind',
	numberTeamsPassLiguilla: 'Number of teams passing wing liguilla',
	season: 'Jahreszeit | Jahreszeiten',
	deliverCup: 'Tasse liefern',
	removeCup: 'BECHER ENTFERNEN',
	toStart: 'ANFANGEN',
	programming: 'PROGRAMMIERUNG',
	inProgress: 'IN BEARBEITUNG',
	finished: 'FERTIG',
	played: 'GESPIELT',
	notPresented: 'Standardmäßig gewonnen',
	changeDatesRounds: 'Datumsrunden ändern',
	addPlayTime: 'Spielzeit hinzufügen',
	selectDays: 'Wählen Sie einen oder mehrere Wochentage aus',
	monday: 'Montag',
	tuesday: 'Dienstag',
	wednesday: 'Mittwoch',
	thursday: 'Donnerstag',
	friday: 'Freitag',
	saturday: 'Samstag',
	sunday: 'Sonntag',
	schedule: 'Spielplan',
	transferDate: 'Überweisungsdatum',
	dateNextSigning: 'Datum der nächsten Unterzeichnung',
	endDate: 'Frist',
	choose: 'Wählen',
	alternate: 'Wechseln',
	showFixture: 'Gerät zeigen',
	msgCreateFixture:
		'Nach dem Erstellen des Spiels können Sie dem Turnier keine Ausrüstung mehr hinzufügen. Sicher weiterzumachen?',
	createFixture: 'Fixture erstellen',
	btnIfContinue: 'Wenn ich weitermachen will',
	createLiguilla: 'Liguilla erstellen',
	thirdPlace: 'Dritter Platz',
	myClub: 'Mein Club',
	myTeams: 'meine Teams',
	myGames: 'Meine Spiele',
	management: 'Verwaltung',
	tshirts: 'T-Shirts',
	notification: 'Benachrichtigung | Benachrichtigungen',
	from: 'Von',
	detailsNotification: 'Detailbenachrichtigung',
	invitation: 'Einladung | Einladungen',
	accept: 'Akzeptieren',
	deny: 'Verweigern',
	invitationAccepted: 'Einladung angenommen.',
	invitationRejected: 'Einladung abgelehnt.',
	transferPlayer: 'Spieler übertragen',
	freePlayerPremium: 'Möchten Sie den ausgewählten Player freigeben??',
	trainingShow: 'Training zu zeigen',
	teamFormation: 'Teambildung',
	myFormation: 'Meine Ausbildung',
	invitePlayers: 'Eingeladene Spieler',
	myFavouriteTeams: 'Meine Lieblingsteams',
	myFavouriteTournaments: 'Meine Lieblingsturniere',
	visitor: 'Besucher',
	watchMatch: 'Spiel ansehen',
	editVideos: 'Videos bearbeiten',
	addPictures: 'Bilder hinzufügen',
	toUpdate: 'Aktualisieren',
	editMatch: 'Bearbeiten Sie die Spielergebnisse',
	participated: 'Beitreten',
	none: 'Keiner',
	changeResultMatch: 'Ändern Sie die Ergebnisse eines Spiels',
	changeResults: 'Ändern Sie die Ergebnisse',
	changeStatistics: 'Ändern Sie die Statistik',
	enabledStatistics: 'Aktivieren Sie die Bearbeitung von Statistiken',
	all: 'Alle',
	coins: 'Münzen',
	duration: 'Dauer',
	toBuy: 'Kaufen',
	relatedProducts: 'Verwandte Produkte',
	purchasedProducts: 'Gekaufte Produkte',
	boughtOn: 'Gekauft am',
	beatOn: 'Schlagen Sie weiter',
	use: 'VERWENDEN',
	addCategory: 'Kategorie hinzufügen',
	bgTournaments: 'Hintergrundbild für die Turniere',
	bgDivisions: 'Hintergrundbild für Abteilungen',
	bgTeams: 'Hintergrundbild für Teams',
	bgPlayers: 'Hintergrundbild für Spieler',
	editCategory: 'Kategorie bearbeiten',
	addSubcategory: 'Unterkategorie hinzufügen',
	editSubcategory: 'Unterkategorie bearbeiten',
	createProduct: 'Produkt erstellen',
	visible: 'Sichtbar',
	editProduct: 'Produkt bearbeiten',
	cardNumber: 'Kartennummer',
	expirationDate: 'Haltbarkeitsdatum',
	matchBetting: 'Match-Wetten',
	matchWin: 'Match gewinnen',
	bet: 'Wette',
	gain: 'Dazugewinnen',
	matchesBet: 'Stimmt mit der Wette überein',
	entry: 'Eintrag',
	betMsgEntry:
		'Es wird abgezogen (<strong>{coin}</strong>) von Ihren Münzen, um dieses Spiel zu spielen',
	confirmResults: 'Ergebnisse bestätigen',
	whatLokingFor: '¿Wonach suchen Sie?',
	textFind: 'Geben Sie 3 Buchstaben oder Zeichen ein',
	searchResults: 'Ergebnisse Ihrer Suche',
	seeCard: 'Siehe Karte',
	only15Letters: 'Nur 15 Zeichen.',
	rename: 'Umbenennen',
	sendLinkResetPassword: 'Passwort per E-Mail ändern',
	end: 'ENDE',
	deliverPrizes: 'Liefere Preise',
	confirm: 'Bestätigen',
	awardsConfirmText:
		'Bist du sicher weiterzumachen? <br />Diese Option kann nicht rückgängig gemacht werden.',
	donateTitle: 'Wir bedanken uns für die Unterstützung',
	donateThanks: 'Danke für deine Unterstützung.',
	donateText:
		'<p>Die Organisation ITFA dankt allen Personen, die auf die eine oder andere Weise die harte Arbeit der Verwaltung dieser Seite schätzen, auf der mehrere Turniere von großem Ansehen und hoher Wettbewerbsfähigkeit organisiert werden.</p><p>An alle diese Sponsoren, die anonym auftreten.</p><p>Wir sind dankbar für den Beitrag, da sie uns motivieren, dieses großartige Projekt fortzusetzen, indem sie die Seite verbessern und pflegen.</p>',
	donate: 'spenden | Spenden',
	amountToDonate: 'Spendenbetrag',
	premiumForMonth:
		'Preis gültig für 1 Monat | Preis gültig für 1 {month} Monat',
	priceForMonth: '1 Monat | {month} Monate',
	movements: 'Bewegungen',
	transferIn: '{player} ist jetzt ein {team} Spieler',
	transferOut: '{player} verließ den Verein {team}',
	changeCup: 'Tasse wechseln',
	banned: 'Verboten',
	reason: 'Grund',
	bannedStart: 'Gestartet',
	bannedEnd: 'Baden',
	countries: 'Länder',
	change: 'Veränderung',
}
